module.exports = __webpack_public_path__ + "c8761c6435ec33c1bdc63ac6ebcba75e.jpg";